
export default {
  props: {
    icon: {
      type: String,
    },
    name: {
      type: String,
    },
    question: {
      type: Boolean,
    },
    input: {
      type: Boolean,
      default: false,
    },
    transparent: Boolean,
  },
  setup() {},
}
